'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAndroid = function MdAndroid(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 8.4v-1.8h-1.6v1.8h1.6z m-8.4 0v-1.8h-1.6v1.8h1.6z m9.3-4.8c2.5 1.8 4.1 4.8 4.1 8h-20c0-3.2 1.6-6.2 4.1-8l-2.2-2.2c-0.3-0.3-0.3-0.9 0-1.2s0.8-0.3 1.1 0l2.5 2.5c1.4-0.7 2.9-1.1 4.5-1.1s3 0.4 4.4 1.1l2.5-2.5c0.3-0.3 0.8-0.3 1.1 0s0.4 0.9 0 1.2z m8.2 9.8c1.4 0 2.5 1.1 2.5 2.5v11.6c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-11.6c0-1.4 1.1-2.5 2.5-2.5z m-28.2 0c1.4 0 2.5 1.1 2.5 2.5v11.6c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-11.6c0-1.4 1.1-2.5 2.5-2.5z m4.1 16.6v-16.6h20v16.6c0 0.9-0.7 1.6-1.6 1.6h-1.8v5.9c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-5.9h-3.2v5.9c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-5.9h-1.8c-0.9 0-1.6-0.7-1.6-1.6z' })
        )
    );
};

exports.default = MdAndroid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/android.js
// module id = 1245
// module chunks = 168707334958949